<template>
  <signup-management-component/>
</template>

<script>
import SignupManagementComponent from '@/spa/components/board/signup-management/BoardSignupManagement';

export default {
  name: 'SignupManagementPage',
  components: {
    SignupManagementComponent,
  },
};
</script>



// WEBPACK FOOTER //
// src/spa/pages/operation/SignupManagementPage.vue